import React from "react";
import { useTranslation } from "react-i18next";

const LoadingPage: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="border-blue-normal mx-auto h-12 w-12 animate-spin rounded-full border-b-2"></div>
        <p className="mt-4 text-gray-600">{t("ui.loading")}</p>
      </div>
    </div>
  );
};

export default LoadingPage;
